import React from "react";

const Linki = () => {
  // Sample links
  const links = [
    {
      id: 1,
      name: "Grupa dietetyczna na facebooku- tylko dla klientów!",
      url: "https://www.facebook.com/share/g/1Cso1dRZkZ/?mibextid=wwXIfr", // Replace with your Facebook group link
    },
    {
      id: 2,
      name: "Kurs dietetyczny- tylko dla klientów!",
      url: "https://youtube.com/playlist?list=PLksplHXw0qE896MfMz8_wWInrKCRpx6hr&si=Pdec2HcbwzMjpMgD", // Replace with your YouTube course link
    },
  ];

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Linki do zasobów</h2>
      <ul className="space-y-4">
        {links.map((link) => (
          <li
            key={link.id}
            className="flex flex-col bg-white p-4 rounded-lg shadow-sm"
          >
            <div className="flex justify-between items-center">
              <span className="text-gray-700">{link.name}</span>
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
              >
                Otwórz
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Linki;
